export default __webpack_public_path__ + "static/media/page1.1e06c402.png";